import { useRef, useCallback, useMemo, PropsWithChildren } from 'react';
import { Toast, ToastMessage } from 'primereact/toast';
import { ToastContext, ToastContextType } from './toast-context';

export const ToastProvider = ({ children }: PropsWithChildren) => {
  const toastRef = useRef<Toast>(null);
  const toastMapRef = useRef(new Map<string, ToastMessage>());

  const getToastMessage = useCallback((id: string) => {
    return toastMapRef.current.get(id);
  }, []);

  const setToastMessage = useCallback((id: string, message: ToastMessage) => {
    toastMapRef.current.set(id, message);
  }, []);

  const deleteToastMessage = useCallback((id: string) => {
    toastMapRef.current.delete(id);
  }, []);

  const clearToastMap = useCallback(() => {
    toastMapRef.current.clear();
  }, []);

  const contextValue: ToastContextType = useMemo(
    () => ({ toastRef, getToastMessage, setToastMessage, deleteToastMessage, clearToastMap }),
    [getToastMessage, setToastMessage, deleteToastMessage, clearToastMap]
  );

  return (
    <ToastContext.Provider value={contextValue}>
      <Toast
        ref={toastRef}
        position="bottom-left"
        onRemove={(message) => {
          if (message.id) {
            toastMapRef.current.delete(message.id);
          }
        }}
      />
      {children}
    </ToastContext.Provider>
  );
};
